"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._DestroyBootstrappedModule = exports._BootstrapModuleIfNoChildModule = exports._BootstrapModule = exports._AllBootstrappedModulesArray = exports._AllBootstrappedModules = exports._BootstrapModules = exports._GetModulesWithoutChildModules = void 0;
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var helper_const_1 = require("@src/const/helper.const");
var module_mapping_1 = require("@src/const/module.mapping");
var notes_mapper_const_1 = require("@src/const/notes-mapper.const");
var reference_object_const_1 = require("@src/const/reference-object.const");
var cash_dom_1 = __importDefault(require("cash-dom"));
var lodash_1 = __importDefault(require("lodash"));
var inter_communication_service_1 = require("./inter-communication.service");
var object_service_1 = require("./object-service");
var settings_service_1 = require("./settings.service");
var _GetModulesWithoutChildModules = function ($container, moduleKey) {
    var selector = moduleKey ? "[data-module=\"".concat(moduleKey, "\"]") : "[data-module]";
    return $container.find(selector).filter(function () {
        return (0, cash_dom_1.default)(this).parentsUntil($container, selector).length === 0;
    });
};
exports._GetModulesWithoutChildModules = _GetModulesWithoutChildModules;
var depth = 1;
var _BootstrapModules = function ($container) { return __awaiter(void 0, void 0, void 0, function () {
    var children, promises, bootstrappedModules, _i, bootstrappedModules_1, module_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                children = (0, exports._GetModulesWithoutChildModules)($container).not('[data-uid]');
                if (!children.length) {
                    console.error('No data-module found in container', $container);
                    return [2 /*return*/];
                }
                promises = [];
                children.each(function (i, element) {
                    var moduleKey = (0, cash_dom_1.default)(element).attr('data-module');
                    var module = module_mapping_1._AllModuleBlueprints[moduleKey];
                    if (!module) {
                        console.error("".concat(moduleKey, " data-module not found - error loading module"));
                        promises.push(Promise.resolve(null));
                    }
                    else {
                        //console.log('MODULE LOG: Start loading module ' + moduleKey);
                        promises.push((0, exports._BootstrapModule)((0, cash_dom_1.default)(element), module));
                    }
                });
                return [4 /*yield*/, Promise.all(promises)];
            case 1:
                bootstrappedModules = _a.sent();
                _i = 0, bootstrappedModules_1 = bootstrappedModules;
                _a.label = 2;
            case 2:
                if (!(_i < bootstrappedModules_1.length)) return [3 /*break*/, 5];
                module_1 = bootstrappedModules_1[_i];
                if (!module_1.$container.find('[data-module]').length) return [3 /*break*/, 4];
                depth++;
                return [4 /*yield*/, (0, exports._BootstrapModules)(module_1.$container)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4:
                _i++;
                return [3 /*break*/, 2];
            case 5:
                console.log('All bootstrapped modules', (0, exports._AllBootstrappedModules)());
                return [2 /*return*/, bootstrappedModules.filter(Boolean)];
        }
    });
}); };
exports._BootstrapModules = _BootstrapModules;
var GlobalBootstrappedModules = {};
var _AllBootstrappedModules = function () {
    return GlobalBootstrappedModules;
};
exports._AllBootstrappedModules = _AllBootstrappedModules;
var _AllBootstrappedModulesArray = function () {
    return Object.values(GlobalBootstrappedModules);
};
exports._AllBootstrappedModulesArray = _AllBootstrappedModulesArray;
/**
 * Expects an element returns a bootstrapped module
 * @param element
 * @param module
 * @returns
 */
var _BootstrapModule = function (container, module, moduleSettings) { return __awaiter(void 0, void 0, void 0, function () {
    var moduleKey, ModuleClass, _a, newInstance, settings, oldSettings, settingService, mergedSettings, bootstrappedModule, moduleRef, references, moduleSpinner, attributes, error_1;
    var _b, _c, _d, _e, _f, _g, _h;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0:
                moduleKey = container.attr('data-module');
                if (!((_b = module.class) !== null && _b !== void 0)) return [3 /*break*/, 1];
                _a = _b;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, ((_c = module.lazyClass) === null || _c === void 0 ? void 0 : _c.call(module))];
            case 2:
                _a = (_j.sent());
                _j.label = 3;
            case 3:
                ModuleClass = _a;
                if (!ModuleClass) {
                    throw new Error("No module class configured for ".concat(moduleKey));
                }
                newInstance = new ModuleClass();
                try {
                    settings = undefined;
                    if ((_d = container.get(0)) === null || _d === void 0 ? void 0 : _d['settings']) {
                        //try getting settings object from dom object
                        settings = (_e = container.get(0)) === null || _e === void 0 ? void 0 : _e['settings'];
                    }
                    else if (container.attr('data-settings')) {
                        //try getting settings object from data attribute
                        settings = JSON.parse(container.attr('data-settings'));
                    }
                    oldSettings = lodash_1.default.cloneDeep(newInstance === null || newInstance === void 0 ? void 0 : newInstance.settings);
                    settingService = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
                    mergedSettings = lodash_1.default.cloneDeep(oldSettings);
                    (0, helper_const_1._DeepMerge)(mergedSettings, (_h = (_g = (_f = settingService === null || settingService === void 0 ? void 0 : settingService.get) === null || _f === void 0 ? void 0 : _f.moduleConfig) === null || _g === void 0 ? void 0 : _g[moduleKey]) !== null && _h !== void 0 ? _h : {});
                    (0, helper_const_1._DeepMerge)(mergedSettings, settings !== null && settings !== void 0 ? settings : {});
                    (0, helper_const_1._DeepMerge)(mergedSettings, moduleSettings !== null && moduleSettings !== void 0 ? moduleSettings : {});
                    newInstance.settings = mergedSettings;
                }
                catch (_k) {
                    //do nothing
                }
                bootstrappedModule = {
                    uid: crypto.randomUUID(),
                    instance: newInstance,
                    $container: container,
                    childModules: [],
                };
                GlobalBootstrappedModules[bootstrappedModule.uid] = bootstrappedModule;
                container.attr('data-uid', bootstrappedModule.uid);
                moduleRef = module_mapping_1._AllModuleBlueprints[moduleKey];
                if ((moduleRef === null || moduleRef === void 0 ? void 0 : moduleRef['encapsulation']) === false) {
                    container.attr('data-encapsulation', 'false');
                }
                if (module === null || module === void 0 ? void 0 : module.references) {
                    references = lodash_1.default.cloneDeep(module.references);
                    (0, reference_object_const_1._RefObjectFinder)(container, references);
                    bootstrappedModule.references = references;
                }
                (0, notes_mapper_const_1._MapNoteFields)(container);
                newInstance.uid = bootstrappedModule.uid;
                newInstance.$container = container;
                newInstance.moduleKey = moduleKey;
                newInstance.module = bootstrappedModule;
                moduleSpinner = (0, generator_const_1._GetComponentLoadingSpinner)();
                container.before(moduleSpinner);
                object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService).sendEvent({
                    module: newInstance,
                    event: 'initialize',
                });
                GlobalBootstrappedModules[bootstrappedModule.uid] = bootstrappedModule;
                _j.label = 4;
            case 4:
                _j.trys.push([4, 6, , 7]);
                attributes = (0, helper_const_1._GetDataAttributesInModule)(container);
                console.log('loading module:', moduleKey, attributes);
                return [4 /*yield*/, newInstance.loadModule(attributes)];
            case 5:
                _j.sent();
                return [3 /*break*/, 7];
            case 6:
                error_1 = _j.sent();
                console.error("LOADING MODULE GONE WRONG \"".concat(moduleKey, "\""), error_1);
                return [3 /*break*/, 7];
            case 7:
                console.log('MODULE LOG: Done with loading ' + moduleKey);
                moduleSpinner.remove();
                object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService).sendEvent({
                    module: newInstance,
                    event: 'loaded',
                    value: { status: 'done', instance: newInstance },
                });
                return [2 /*return*/, bootstrappedModule];
        }
    });
}); };
exports._BootstrapModule = _BootstrapModule;
/**
 * Bootstraps requested module if not already existent in $container
 * @param $container
 * @param key
 * @param module
 */
var _BootstrapModuleIfNoChildModule = function ($container, key, moduleSettings) { return __awaiter(void 0, void 0, void 0, function () {
    var moduleContainer;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                moduleContainer = (0, exports._GetModulesWithoutChildModules)($container, key);
                if (moduleContainer === null || moduleContainer === void 0 ? void 0 : moduleContainer.length) {
                    if (GlobalBootstrappedModules[moduleContainer.attr('data-uid')]) {
                        //module already bootstrapped return it
                        return [2 /*return*/, GlobalBootstrappedModules[moduleContainer.attr('data-uid')]];
                    }
                    else {
                        //module was added by designer but not bootstrapped yet
                    }
                }
                else {
                    //module wasnt bootstrapped and not added by designer
                    console.error('You didnt add the module which is required therefore the framework added it for you', key);
                    moduleContainer = (0, cash_dom_1.default)('<div>').attr('data-module', key);
                    $container.append(moduleContainer);
                }
                return [4 /*yield*/, (0, exports._BootstrapModule)(moduleContainer, module_mapping_1._AllModuleBlueprints[key], moduleSettings)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports._BootstrapModuleIfNoChildModule = _BootstrapModuleIfNoChildModule;
/**
 * removes module and all references
 */
var _DestroyBootstrappedModule = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/];
}); }); };
exports._DestroyBootstrappedModule = _DestroyBootstrappedModule;
